import { render, staticRenderFns } from "./CustomUIProject.vue?vue&type=template&id=9bbde6da&scoped=true"
import script from "./CustomUIProject.vue?vue&type=script&lang=js"
export * from "./CustomUIProject.vue?vue&type=script&lang=js"
import style0 from "./CustomUIProject.vue?vue&type=style&index=0&id=9bbde6da&prod&scoped=true&lang=css"
import style1 from "./CustomUIProject.vue?vue&type=style&index=1&id=9bbde6da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbde6da",
  null
  
)

export default component.exports